let bodyScrollLock: any
if (typeof window !== 'undefined') {
  bodyScrollLock = require('body-scroll-lock')
}
import * as React from 'react'

import { CSSTransition } from 'react-transition-group'
import Button from '../button/button'
import Logo from '../logo/logo'
import Navigation from '../navigation/navigation'
import SingInUrlProvider from '../signin/SignInUrlProvider'
import Hamburger from './components/hamburger/hamburger'

import './header.scss'

interface IHeaderMenuState {
  readonly hamburgerIsOpen: boolean
  readonly passedScrollLimit: boolean
}

interface IHeaderMenuProps {
  readonly theme?: string
  readonly isSticky?: boolean
}

const defaultProps = {
  theme: 'dark' as 'dark' | 'light',
  isSticky: false,
}

class Header extends React.Component<IHeaderMenuProps, IHeaderMenuState> {
  private static defaultProps = defaultProps
  private navigationRef: HTMLElement = null

  constructor(props: IHeaderMenuProps) {
    super(props)

    this.state = {
      hamburgerIsOpen: false,
      passedScrollLimit: false,
    }
    this.hamburgerStateHandler = this.hamburgerStateHandler.bind(this)
  }

  public hamburgerStateHandler() {
    if (this.state.hamburgerIsOpen) {
      bodyScrollLock.enableBodyScroll(this.navigationRef)
      typeof window !== 'undefined' &&
        window.removeEventListener('resize', this.handleResize)
    } else {
      bodyScrollLock.disableBodyScroll(this.navigationRef)
      typeof window !== 'undefined' &&
        window.addEventListener('resize', this.handleResize)
    }

    this.setState({ hamburgerIsOpen: !this.state.hamburgerIsOpen })
  }

  public componentDidMount() {
    if (this.props.isSticky) {
      typeof window !== 'undefined' &&
        window.addEventListener('scroll', this.handleScroll)
    }

    this.navigationRef = document.querySelector(
      '#navigation .navigation__content',
    )
  }

  public componentWillUnmount() {
    if (this.props.isSticky) {
      typeof window !== 'undefined' &&
        window.removeEventListener('scroll', this.handleScroll)
    }

    bodyScrollLock.clearAllBodyScrollLocks()
    typeof window !== 'undefined' &&
      window.removeEventListener('resize', this.handleResize)
  }

  public handleTouchMove = (event: Event) => {
    event.preventDefault()
  }

  public handleResize = () => {
    const LG_MINIMUM_WIDTH = 992

    // Check if user is resizing window and if it is
    // bigger or equal than LG breakpoint
    if (document.body.clientWidth >= LG_MINIMUM_WIDTH) {
      // Enable scroll again
      bodyScrollLock.enableBodyScroll(this.navigationRef)

      // Close mobile menu
      this.setState({ hamburgerIsOpen: false })

      // remove listener since it is not needed anymore
      typeof window !== 'undefined' &&
        window.removeEventListener('resize', this.handleResize)
    }
  }

  public handleScroll = () => {
    const distanceFromTop = window.scrollY
    const DISTANCE_GAP = 140

    if (
      distanceFromTop >= DISTANCE_GAP &&
      this.state.passedScrollLimit === false
    ) {
      this.setState({ passedScrollLimit: !this.state.passedScrollLimit })
    } else if (
      distanceFromTop < DISTANCE_GAP &&
      this.state.passedScrollLimit === true
    ) {
      this.setState({ passedScrollLimit: !this.state.passedScrollLimit })
    }
  }

  public handleClickSlack = () => {
    analytics.track('Slack Account OAuth Initiated', {
      category: 'Visitor',
      label: 'Sign In With Slack [header]',
    })
  }

  public render() {
    const extraClasses = [`header-main--${this.props.theme}`]

    if (this.state.hamburgerIsOpen) {
      extraClasses.push('header-main--open')
    }

    if (this.props.isSticky) {
      extraClasses.push('header-main--sticky')
    }

    return (
      <header>
        <div
          className={`header-main ${extraClasses.join(' ')} ${
            this.props.isSticky && this.state.passedScrollLimit
              ? 'js-active'
              : ''
          }`}>
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="header-main__wrapper">
                  <div className="header-main__left">
                    <Logo />
                    <Navigation />
                  </div>
                  <div className="header-main__right">
                    {/* <SingInUrlProvider>
                      <Button
                        extraClasses="btn--slack"
                        content=""
                        onClick={this.handleClickSlack}
                      />
                    </SingInUrlProvider> */}
                    <Hamburger
                      handle={this.hamburgerStateHandler}
                      isOpen={this.state.hamburgerIsOpen}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CSSTransition
          in={this.state.hamburgerIsOpen}
          classNames="menu"
          timeout={450}>
          <Navigation
            extraClasses="navigation--mobile navigation--header"
            showButton={true}
          />
        </CSSTransition>
      </header>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/header/header.tsx